import * as React from 'react';
import type { UserPickerProps, User } from 'view/common/fields/user-picker';
import { UserPicker } from 'view/common/fields/user-picker';

interface Props extends UserPickerProps {
	portalId: number;
	defaultReporter?: User;
}

type FinalProps = Omit<Props, 'defaultUser' | 'required'>;

class Reporter extends React.PureComponent<FinalProps> {
	render() {
		return (
			<UserPicker {...this.props} defaultUser={this.props.defaultReporter} id="reporter" required />
		);
	}
}

export default Reporter;
